import { z } from "zod";
import { BaseOutputSchema } from "./BaseOutput";
import { GetLatestLinkOutputSchema } from "./GetLatestLinkOutput";

export const GetMagicLinkConfigOutputSchema = BaseOutputSchema.extend({
    emails: z.array(z.string()),
    phones: z.array(z.string()),
    isIdCardUploadRequiredForRequest: z.boolean().default(false),
    idCardFrontTaxonomyId: z.number().nullish(),
    idCardBackTaxonomyId: z.number().nullish(),
    latestMagicLink: GetLatestLinkOutputSchema.nullish(),
});

export type GetMagicLinkConfigOutput = z.infer<typeof GetMagicLinkConfigOutputSchema>;

